import { useParams } from "react-router-dom"
import { Vazio } from "@/kit/Vazio"
import { GradePinout } from "./pinout/GradePinout"
import { PinoutInterno as GradeInterna } from "./pinout/interno/PinoutInterno"

export function Pinout({ modo }: { modo: "externo" | "interno" }) {
  const { projetoId } = useParams()
  const id = Number(projetoId)

  if (modo === "interno") return <GradeInterna />

  if (!Number.isFinite(id) || id <= 0) {
    return (
      <Vazio
        semana="Pinout"
        titulo="Abra um projeto primeiro"
        o_que="A grade de pinout é sempre de um projeto: sem projetoId não há o que listar."
      />
    )
  }

  return <GradePinout projetoId={id} />
}
